import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from 'sweetalert2';
import { MsgResponse } from '@core/models/MsgResponse';

@Injectable({
  providedIn: 'root'
})
export class HttpMesageHandlerService {

  constructor() {}

  handleMsg(res: HttpErrorResponse | MsgResponse): void {
    if(!res) return;
    let error: any = res instanceof HttpErrorResponse ? res.error : res;

    if (
      res instanceof HttpErrorResponse &&
      typeof res.error === 'string' &&
      res.error.startsWith('{\"code\":')
    ) {
      try {
        const parsedError = JSON.parse(res.error);
        this.handleMsg(parsedError);
        return;
      } catch (e) {

      }
    }

    const hasCode = error?.code !== undefined && error?.code !== null && String(error.code).trim() !== '';
    const hasToast = typeof error?.toast === 'string' && error.toast.trim() !== '';

    if (!hasCode && !hasToast) {
      this.showUnexpectedErrorAlert();
      return;
    }

    const title = hasCode ? String(error.code) : 'Error';
    const text = error?.message || 'Ha ocurrido un error inesperado. Intente de nuevo o contacte con soporte.';
    const footer = error?.descripcion?.[0] || '';
    const icon = hasToast ? error.toast : 'error';

    Swal.fire({
      icon,
      title,
      text,
      footer,
    }).then();
  }

  showUnexpectedErrorAlert(): void {
    Swal.fire({
      icon: 'error',
      title: 'Error inesperado',
      text: 'Ha ocurrido un error inesperado. Intente de nuevo o contacte con soporte.',
    }).then();
  }
}
